import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { ContactValues } from "@/features/purchase-ticket/schema/contact.schema";

interface ContactState {
  contact: ContactValues | null;
  setContact: (contact: ContactValues) => void;
  clearContact: () => void;
}

export const useContactStore = create<ContactState>()(
  persist(
    (set) => ({
      contact: null,

      setContact: (contact) => {
        set({ contact });
      },

      clearContact: () => {
        set({ contact: null });
      },
    }),
    {
      name: "contact-store",
    },
  ),
);